<template>
  <h2 class="w-full">{{ $t('da-zao-ni-de-3d-shu-zi-ren') }}</h2>
  <div class="component-avatar">
    <nuxt-link :to="{ path: '/characters' }" class="more-btn">
      {{ $t('cha-kan-geng-duo') }}
      <iconpark-icon name="arrowright" size="16"></iconpark-icon>
    </nuxt-link>
    <div
      v-for="(item, idx) in displayList"
      :key="item.id"
      class="card"
      @mouseover="handleHover(item)"
      @mouseleave="handleLeave()"
    >
      <nuxt-link
        :to="{
          name: PageKey.CHARACTER_DETAIL,
          params: { look_name: item.identity },
        }"
        class="link"
        target="_blank"
      >
        <Resource
          v-if="idx < 3"
          class="w-[30px] z-10 rank"
          :src="
            getFeUrl(
              isChinese()
                ? `/youyan-platform/png/home/home-rank-${idx + 1}.png`
                : `/rendora/home/home-rank-${idx + 1}.png`
            )
          "
        >
        </Resource>
        <!-- <iconpark-icon class="rank z-10" :name="`rank-${idx + 1}`" size="36" /> -->
        <Resource
          :src="item.homepage_cover_url || item.url"
          class="avatar"
          :resource-option="{
            format: 'webp',
            resize: {
              w: 500,
              m: 'lfit',
            },
          }"
          :alt="item.name"
        />
        <Resource
          v-if="currentHover === item"
          :src="item.preview_videos[currentPlay]"
          autoplay
          class="avatar-video"
          @ended="handleAvatarVideoEnded"
        />
      </nuxt-link>

      <div class="footer">
        <CardAction
          v-if="!isChinese()"
          :leftTip="$t('bian-ji-ren-wu')"
          :rightText="$t('yong-ta-chuang-zuo')"
          @click-left="createOps(item, 'image')"
          @click-right="createOps(item, 'person')"
        >
          <template #leftIcon>
            <iconpark-icon name="edit"></iconpark-icon>
          </template>
        </CardAction>

        <template v-else>
          <a-button
            class="btns left"
            type="default"
            @click.stop="createOps(item, 'image')"
          >
            {{ $t('bian-ji-ren-wu') }}
          </a-button>
          <a-button
            type="primary"
            class="btns right"
            @click.stop="createOps(item, 'person')"
          >
            {{ $t('yong-ta-chuang-zuo') }}
          </a-button>
        </template>
      </div>
      <div class="info">
        <div class="name">{{ item.name }}</div>
        <div class="tag">
          {{ [0, 10].includes(item.config_type) ? $t('ge-ren') : $t('qi-ye') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  getCharacterCollectionPage,
  type ICharacter,
} from '~/api/module/material'
import { getTagByOuterId } from '~/api/module/tags'
import { ACTOR_NAV, CONFIG_NAV, CONTENT_TABS } from '~/constants'
import { PageKey } from '~/constants/page'
import { createWorkByCharacter } from '~/features/createWork/utils'
import CardAction from '~/components/card-action/index.vue'

const currentPlay = ref(0)
const currentHover = ref<ICharacter | null>(null)

const handleAvatarVideoEnded = () => {
  if (currentHover.value?.preview_videos.length === currentPlay.value + 1) {
    currentPlay.value = 0
    return
  }
  currentPlay.value++
}

const handleHover = (item: ICharacter) => {
  currentPlay.value = 0
  currentHover.value = item
}

const handleLeave = () => {
  currentHover.value = null
}

const nuxtApp = useNuxtApp()

// todo: 这里后面最好合成为一个接口
const { data: list } = useAsyncData(async () => {
  const tag = await getTagByOuterId('character_show_of_index')
  return getCharacterCollectionPage(
    {
      o: '-score',
      tag_id: String(tag.data?.[0].id),
      page_size: 5,
      many: 1,
    },
    nuxtApp
  )
})

const createOps = (item: ICharacter, type: 'image' | 'person') => {
  if (type === 'image') {
    createWorkByCharacter(item.id, CONFIG_NAV.ACTOR, ACTOR_NAV.CHARACTER)
  } else {
    createWorkByCharacter(item.id, CONFIG_NAV.CONTENT, CONTENT_TABS.CHARACTER)
  }
}

const displayList = computed(() => {
  return list.value?.data?.results || []
})
</script>

<style lang="scss" scoped>
.component-avatar {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: rem(12);
}
.more-btn {
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  top: rem(-40);
  font-size: rem(14);
  line-height: 1;
  color: var(--text-1);
  opacity: 0.6;
  &:hover {
    opacity: 0.9;
  }
}

.card {
  cursor: pointer;
  width: rem(230);
  height: rem(290);
  border-radius: rem(12);
  position: relative;
  overflow: hidden;

  &:hover {
    .footer {
      transform: translateY(rem(-60));
      visibility: visible;
    }
    .info {
      display: none;
    }
  }

  .footer {
    @apply absolute flex-y-center justify-center;
    transition: transform 0.12s ease-out;
    gap: rem(7);
    width: 100%;
    bottom: rem(-40);
    visibility: hidden;
    .btns {
      font-weight: 600;
      font-weight: bold;
      border-radius: rem(24);
      text-align: center;
      height: rem(32);
      font-weight: 500;
      box-shadow: none;
      font-size: 14px;
      &.left {
        width: rem(96);
      }
      &.right {
        width: rem(107);
      }
    }
  }

  .tag {
    display: flex;
    justify-content: center;
    align-items: center;
    height: rem(16);
    padding: 0 8px;
    border-radius: rem(10);
    border: 1px solid rgba(255, 255, 255, 0.302);
    color: #fff;
    font-size: rem(8);
  }

  .info {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 rem(16);
    height: rem(48);
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  .name {
    font-size: rem(12);
    color: #fff;
    opacity: 0.8;
  }

  .avatar-video {
    position: absolute;
    left: 0;
    top: 0;
  }

  .avatar,
  .avatar-video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .rank {
    position: absolute;
    left: rem(-1);
    top: 0;
  }

  .link {
    position: absolute;
    content: ' ';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }

  &:nth-child(2) {
    background: linear-gradient(180deg, #494c53 0%, #7a7d85 100%);
  }
  &:nth-child(3) {
    background: linear-gradient(180deg, #2c2c2c 0%, #575757 100%);
  }
  &:nth-child(4) {
    background: linear-gradient(180deg, #433a44 0%, #6b656c 100%);
  }
  &:nth-child(5) {
    background: linear-gradient(180deg, #707070 0%, #9b9b9b 100%);
  }
  &:nth-child(6) {
    background: linear-gradient(180deg, #4b4749 0%, #726e6f 100%);
  }
}
</style>
